"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buyBoxNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
const normalizeOrionStructure = (product) => {
    if (!product)
        return null;
    const res = {
        "Button-1": Object.assign({}, mocks_json_1.default["Button-1"]),
        "Text-1": Object.assign({}, mocks_json_1.default["Text-1"]),
        "Text-2": Object.assign({}, mocks_json_1.default["Text-2"]),
        "Text-3": Object.assign({}, mocks_json_1.default["Text-3"]),
        "Text-4": Object.assign({}, mocks_json_1.default["Text-4"]),
        // "Label-1": { ...mock["Label-1"] },
        "Price-1": Object.assign({}, mocks_json_1.default["Price-1"]),
        "Price-2": Object.assign({}, mocks_json_1.default["Price-2"]),
        "Legal-1": Object.assign({}, mocks_json_1.default["Legal-1"]),
    };
    if (product === null || product === void 0 ? void 0 : product.href) {
        res["Button-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Button-1"]), { href: product.href });
    }
    if (product === null || product === void 0 ? void 0 : product.textButton) {
        res["Button-1"].text = product === null || product === void 0 ? void 0 : product.textButton;
    }
    if (product === null || product === void 0 ? void 0 : product.price) {
        res["Price-2"].price = product.price;
    }
    if (product === null || product === void 0 ? void 0 : product.unidad) {
        res["Price-2"].currency = product.unidad;
    }
    if (product === null || product === void 0 ? void 0 : product.topDescription) {
        res["Text-0"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-0"]), { text: product === null || product === void 0 ? void 0 : product.topDescription });
    }
    if (product === null || product === void 0 ? void 0 : product.upDescription) {
        res["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: product === null || product === void 0 ? void 0 : product.upDescription });
    }
    if (product === null || product === void 0 ? void 0 : product.postButtonTextMobile) {
        res["TextMobile-1"] = Object.assign(Object.assign({}, mocks_json_1.default["TextMobile-1"]), { text: product === null || product === void 0 ? void 0 : product.postButtonTextMobile });
    }
    return res;
};
/**
 * normalizador del modulo MODULO_BUYBOX
 * @param {object} fields
 * @returns
 */
const buyBoxNormalizer = (data) => {
    var _a, _b, _c, _d;
    try {
        let res = {};
        const buyboxOne = (_b = (_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.buyboxList[0]) === null || _b === void 0 ? void 0 : _b.fields;
        const buyboxTwo = (_d = (_c = data === null || data === void 0 ? void 0 : data.fields) === null || _c === void 0 ? void 0 : _c.buyboxList[1]) === null || _d === void 0 ? void 0 : _d.fields;
        res["Product-1"] = Object.assign(Object.assign({}, normalizeOrionStructure(buyboxOne)), { "Phone-Module": normalizeOrionStructure(buyboxTwo) });
        res["Product-2"] = null;
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.buyBoxNormalizer = buyBoxNormalizer;
exports.default = exports.buyBoxNormalizer;
//# sourceMappingURL=index.js.map